import { Staff } from '@/models/Entities/Personas/Staff';

export class UnitRepresentative extends Staff {}
